<div class="title mb-4">
  <h2>Add URL</h2>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="white_box shadow p-3">
      <div class="row">
        <div class="col-md-8">
          <div class="nm_contact">
            <h4>URL DETAILS</h4>
            <form [formGroup]="url_form">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="url_name"
                  placeholder="Company Name"
                />
                <ng-container *ngIf="submitted && url_form_v.url_name.errors">
                  <p
                    class="error-message"
                    style="padding: 10px; font-size: 12px; float: left"
                    *ngIf="url_form_v.url_name.errors.required"
                  >
                    Company Name is required!
                  </p>
                </ng-container>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="Whatsapp_link"
                  placeholder="Whatsapp link"
                />
                <ng-container
                  *ngIf="submitted && url_form_v.Whatsapp_link.errors"
                >
                  <p
                    class="error-message"
                    style="padding: 10px; font-size: 12px; float: left"
                    *ngIf="url_form_v.Whatsapp_link.errors.required"
                  >
                    Whatsapp link is required!
                  </p>
                </ng-container>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  formControlName="review_link"
                  placeholder="Review link"
                />
                <ng-container
                  *ngIf="submitted && url_form_v.review_link.errors"
                >
                  <p
                    class="error-message"
                    style="padding: 10px; font-size: 12px; float: left"
                    *ngIf="url_form_v.review_link.errors.required"
                  >
                    Review link is required!
                  </p>
                </ng-container>
              </div>
              <div class="form-group">
                <textarea
                  class="form-control"
                  rows="4"
                  formControlName="sms_content"
                  placeholder="Thank you Content"
                ></textarea>
                <ng-container
                  *ngIf="submitted && url_form_v.sms_content.errors"
                >
                  <p
                    class="error-message"
                    style="padding: 10px; font-size: 12px; float: left"
                    *ngIf="url_form_v.sms_content.errors.required"
                  >
                    SMS Content is required!
                  </p>
                </ng-container>
              </div>
              <div class="form-group">
                <select class="form-control" formControlName="version">
                  <option value="" selected disabled>Select version</option>
                  <option value="0">Version 1</option>
                  <option value="1">Version 2</option>
                </select>
                <ng-container *ngIf="submitted && url_form_v.version.errors">
                  <p
                    class="error-message"
                    style="padding: 10px; font-size: 12px; float: left"
                    *ngIf="url_form_v.version.errors.required"
                  >
                    Version is required!
                  </p>
                </ng-container>
              </div>
            </form>
          </div>
        </div>
        <div class="col-md-4">
          <div class="nm_contact">
            <a class="com_btn" (click)="add_url_and_sms_content_sub()">Save </a>
          </div>
        </div>

        <div class="col-md-12">
          <!-- <app-feedback-manager-sub></app-feedback-manager-sub> -->
        </div>
      </div>
    </div>
  </div>
</div>
